/* eslint-disable react/jsx-no-bind */
/* @flow */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import * as queryString from 'query-string';

import DataUtils from 'common/utils/DataUtils';
import loginIds from 'common/tests/login/loginIds.json';
import { Stack, Input, Button } from '@locus-taxy/neo-ui';

const ClientIdForm = (): React.Node => {
    const { t } = useTranslation('settings');
    const history = useHistory();
    const location = useLocation();
    const [inputClientId, setClientId] = React.useState();
    const isDisabled = DataUtils.isEmpty(inputClientId);

    const cancelFormSubmit = (event: Event) => {
        event.preventDefault();
    };

    const onClientIdChange = event => {
        setClientId(event.target.value);
    };

    const onClientIdNext = event => {
        event.preventDefault();
        const modifiedQueries = {
            ...queryString.parse(location.search),
            clientId: inputClientId
        };

        // add clientId to URL on next
        const search = queryString.stringify(modifiedQueries);
        history.replace({ ...location, search });
    };

    return (
        <Stack
            as="form"
            space="large"
            onSubmit={!isDisabled ? onClientIdNext : cancelFormSubmit}
        >
            <Input
                autoFocus
                label={t('clientId')}
                placeholder={t('enterClientId')}
                data-test-id={loginIds.inputs.clientIdInput}
                type="text"
                size="large"
                value={inputClientId}
                onChange={onClientIdChange}
            />
            <Button
                type="submit"
                disabled={isDisabled}
                appearance="solid"
                palette="primary"
                size="large"
                data-test-id={loginIds.buttons.continueClientId}
            >
                {t('continue')}
            </Button>
        </Stack>
    );
};

export default ClientIdForm;
